var _excluded = ["href", "onClick"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import BaseLink from "../../Link/BaseLink";
import isAppRouteContext from "../isAppRouteContext";

var IsAppRouteLink = function IsAppRouteLink(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(isAppRouteContext),
      isAppRoute = _useContext.isAppRoute,
      linkComponent = _useContext.linkComponent;

  return /*#__PURE__*/React.createElement(BaseLink, _extends({
    Component: isAppRoute(href) ? linkComponent : undefined,
    href: href,
    onClick: onClick
  }, props));
};

IsAppRouteLink.propTypes = process.env.NODE_ENV !== "production" ? {
  href: PropTypes.string,
  onClick: PropTypes.func
} : {};
export default IsAppRouteLink;
//# sourceMappingURL=IsAppRouteLink.js.map